import Scroll from './Scroll/Scroll';

const Animated = {
  Scroll,
};

export default Animated;
